export default __webpack_public_path__ + "static/media/gamebling-l.cf7f7c3f.png";